// extracted by mini-css-extract-plugin
export var modal = "_fx-0";